import React from 'react';
import propTypes from 'prop-types';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { PrimaryButton, ClearButton } from 'ui/Components';

/**
 * This component can be used to show a modal with No and Yes buttons.
 * @returns {React.Component} a react component with No and Yes buttons
 */
const ConfirmationModal = ({
  children,
  headerText,
  isOpen,
  onNoClick,
  onOkClick,
  onYesClick,
  yesButtonLabel,
  noButtonLabel,
  okButtonLabel
}) => (
  <Modal isOpen={isOpen} data-test-id="confirmationModal-modal">
    {headerText && <ModalHeader>{headerText}</ModalHeader>}
    <ModalBody>{children}</ModalBody>
    <ModalFooter>
      {onNoClick && (
        <ClearButton onClick={onNoClick} data-test-id="confirmationModal-no">
          {noButtonLabel}
        </ClearButton>
      )}
      {onYesClick && (
        <PrimaryButton onClick={onYesClick} data-test-id="confirmationModal-yes">
          {yesButtonLabel}
        </PrimaryButton>
      )}
      {onOkClick && (
        <PrimaryButton onClick={onOkClick} data-test-id="confirmationModal-ok">
          {okButtonLabel}
        </PrimaryButton>
      )}
    </ModalFooter>
  </Modal>
);

ConfirmationModal.propTypes = {
  children: propTypes.node,
  headerText: propTypes.string,
  yesButtonLabel: propTypes.string,
  noButtonLabel: propTypes.string,
  okButtonLabel: propTypes.string,
  isOpen: propTypes.bool,
  onNoClick: propTypes.func,
  onOkClick: propTypes.func,
  onYesClick: propTypes.func
};

ConfirmationModal.defaultProps = {
  children: undefined,
  headerText: null,
  yesButtonLabel: 'Yes',
  noButtonLabel: 'No',
  okButtonLabel: 'Ok',
  isOpen: false,
  onNoClick: undefined,
  onOkClick: undefined,
  onYesClick: undefined
};

export default ConfirmationModal;
